<template>
    <view-card headline="실측자료">
        <!-- nav -->
        <v-tabs v-model="tab">
            <v-tab v-for="{ name, nameKr } in initialMeasurements" :key="name" :style="!disabled || (disabled && hasDataSections(name)) ? null : 'display:none;'">{{ nameKr }}</v-tab>
        </v-tabs>
        <hr />
        <v-tabs-items v-model="tab" class="pa-4">
            <v-tab-item v-for="{ name: areaName, nameKr: areaNameKr, sections } in measurements" :key="areaName">
                <v-row>
                    <v-col
                        v-for="({ name: sectionName, nameKr: sectionNameKr, images }, index) in sections.filter((section) => (!disabled ? true : section.images.length || section.detail.length))"
                        :key="sectionName"
                        cols="4"
                        class="px-8 my-4"
                        :style="(index + 1) % 3 ? 'border-right:1px solid rgba(0,0,0,0.2);' : null"
                    >
                        <v-row align="center">
                            <v-col cols="auto" class="text-h6 font-weight-bold">{{ sectionNameKr }}</v-col>
                            <v-spacer />
                            <v-col cols="auto">
                                <v-btn v-if="!disabled" @click="images.push(null)" small color="secondary">
                                    이미지 추가
                                    <v-icon small class="ml-1">mdi-plus-circle</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row v-for="(image, index) in images" :key="`${areaName}-${sectionName}-image-${index}`" align="center">
                            <v-col cols="auto" :style="disabled ? 'cursor:pointer' : null">
                                <v-img v-if="image" :max-width="disabled ? '100%' : '96'" :max-height="disabled ? null : '96'" :src="createObjectURL(image)" @click="showOverlay(image)" contain />
                                <v-responsive v-else width="96" height="96" class="grey lighten-2">
                                    <v-row align="center" class="fill-height" justify="center"><v-icon color="black">mdi-pencil</v-icon></v-row>
                                </v-responsive>
                            </v-col>
                            <v-col v-if="!disabled">
                                <v-file-input v-model="images[index]" label="썸네일 이미지" placeholder=" " class="mt-2 mx-3" show-size accept="image/*"></v-file-input>
                            </v-col>
                            <v-col v-if="!disabled" cols="auto">
                                <v-icon @click="images = images.splice(index, 1)" color="red">mdi-minus-circle</v-icon>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    v-if="!disabled || getItem(areaName, sectionName).detail.length"
                                    v-model="getItem(areaName, sectionName).detail"
                                    label="상세정보"
                                    placeholder=" "
                                    hide-details
                                    :readonly="disabled"
                                />
                            </v-col>
                        </v-row>
                        <v-row v-if="!disabled" justify="end">
                            <v-col cols="auto">
                                <v-btn small color="primary" @click="save({ areaName, areaNameKr, sectionName })">저장</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-tab-item>
        </v-tabs-items>
        <view-overlay :overlay="overlay" @hide-overlay="hideOverlay" />
    </view-card>
</template>
<script>
import viewCard from "../dumb/view-card.vue";
import initialMeasurements from "@/assets/data/initialInquiryMeasurements";
import api from "@/api";
import ViewOverlay from "../dumb/view-overlay.vue";

export default {
    components: { viewCard, ViewOverlay },
    props: {
        disabled: { type: Boolean, default: true },
        value: { type: Array, default: null },
        _inquiry: { type: String, default: null },
    },
    data() {
        return {
            tab: 0,
            overlay: {
                show: false,
                src: null,
            },
            initialMeasurements,
            measurements: [...initialMeasurements],
        };
    },
    created() {
        this.init();
    },
    methods: {
        async init() {
            if (this.value)
                try {
                    for (const { name: areaName, sections } of this.value) {
                        const area = this.measurements.find(({ name }) => name == areaName);

                        if (area) {
                            for (let { name: sectionName, detail, images } of sections) {
                                const section = area.sections.find(({ name }) => name == sectionName);

                                if (section) {
                                    images = JSON.parse(JSON.stringify(images));
                                    detail = JSON.parse(JSON.stringify(detail));

                                    for (let index = 0; index < images.length; index++) {
                                        const image = images[index];
                                        images[index] = await api.getResource(image);
                                    }

                                    section.images = images;
                                    section.detail = detail;
                                }
                            }
                        }
                    }
                } catch (error) {
                    this.handleError(error);
                }
        },
        async save({ areaName, areaNameKr, sectionName }) {
            try {
                const target = this.getItem(areaName, sectionName);

                const { images, ...section } = target;

                // data upload
                const inquiry = { _id: this._inquiry, measurements: [{ name: areaName, nameKr: areaNameKr, sections: target ? [section] : [] }] };
                await api.console.estimate.inquiries.putInquiry(inquiry);

                // resource upload
                if (target.images.length > 0) {
                    for (let index = 0; index < target.images.length; index++) {
                        const image = target.images[index];
                        await api.console.estimate.inquiries.postMeasurements({ _id: this._inquiry, areaName, sectionName, index }, image);
                    }
                }

                alert("저장되었습니다.");
            } catch (error) {
                this.handleError(error);
            }
        },
        handleError(error) {
            console.error(error);
            alert(error.response ? error.response.data.message : error.message);
        },
        createObjectURL(file) {
            try {
                return URL.createObjectURL(file);
            } catch (error) {
                return;
            }
        },
        getItem(areaName, sectionName) {
            return this.measurements.find(({ name }) => name == areaName)?.sections.find(({ name }) => name == sectionName);
        },
        hasDataSections(_name) {
            return this.measurements.find(({ name }) => name == _name).sections.filter(({ images, detail }) => images.length || detail.length).length;
        },
        showOverlay(image) {
            const { disabled, overlay } = this;
            if (disabled) {
                overlay.show = true;
                overlay.src = this.createObjectURL(image);
            }
        },
        hideOverlay() {
            this.overlay = { show: false, src: undefined };
        },
    },
};
</script>
